import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  TextField,
  Typography,
  CircularProgress,
  Divider,
  Grid,
  MenuItem
} from '@material-ui/core';
import React, { useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { addSystemTopup } from 'src/store/actions/TopupActions';

function SystemTopup({ open, handleClose }) {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const profile = useSelector((state) => state.Auth.profile);
  const issuersData = useSelector((state) => state.Logs.issuersData);

  const handleSystemTopup = async (values) => {
    setLoading(true);
    const response = await dispatch(addSystemTopup(values));
    if (response === 1) {
      setLoading(false);
      handleClose();
    } else {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <Typography color="textPrimary" variant="h2">
          Add Topup
        </Typography>
      </DialogTitle>
      <Divider />
      <Formik
        initialValues={{
          amount: '',
          reason: '',
          issuerID: ''
        }}
        validationSchema={Yup.object().shape({
          amount: Yup.string().trim().max(255).required('Amount is required'),
          reason: Yup.string().trim().max(255).required('Reason is required'),

          issuerID: Yup.string().max(255).required('Client is required')
        })}
        onSubmit={(values) => {
          handleSystemTopup(values);
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          touched,
          values
        }) => (
          <form onSubmit={handleSubmit}>
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    error={Boolean(touched.issuerID && errors.issuerID)}
                    helperText={touched.issuerID && errors.issuerID}
                    fullWidth
                    select
                    margin="dense"
                    name="issuerID"
                    label="Client"
                    required
                    variant="outlined"
                    onBlur={handleBlur}
                    size="small"
                    onChange={handleChange}
                    value={values.issuerID}
                  >
                    <MenuItem value="">Please select Client</MenuItem>
                    {issuersData &&
                      issuersData.map((item, index) => (
                        <MenuItem key={index} value={item.issuerID}>
                          {item.fullname}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    error={Boolean(touched.amount && errors.amount)}
                    fullWidth
                    helperText={touched.amount && errors.amount}
                    label="Amount"
                    margin="dense"
                    name="amount"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type="number"
                    value={values.amount}
                    variant="outlined"
                    size="small"
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    error={Boolean(touched.reason && errors.reason)}
                    fullWidth
                    helperText={touched.reason && errors.reason}
                    label="Reason"
                    margin="dense"
                    name="reason"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type="text"
                    multiline
                    rows={4}
                    value={values.reason}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button variant="outlined" onClick={handleClose}>
                Close
              </Button>
              <Button
                disabled={loading}
                variant="contained"
                color="primary"
                type="submit"
              >
                {loading && <CircularProgress size="1.5rem" />}
                Submit
              </Button>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  );
}

export default SystemTopup;
